import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19 11H1a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2zm0-7H1a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2zm0 14H1a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2z"
});

var SvgMobileHamburgerMajorMonotone = function SvgMobileHamburgerMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgMobileHamburgerMajorMonotone as S };
